import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [ "videoWrap", "video", "thumb" ]
    
    connect() {
        const videoElement = this.videoTarget;
        const videoWrapElement = this.videoWrapTarget;

        if(document.getElementsByClassName(".video-thumb")[0]){
            const thumbElement = this.thumbTarget;
        }
        
        let wrapID = videoElement.getAttribute('id');
        let videoID = videoElement.getAttribute('data-video-id');
        let isAutoplay = videoElement.getAttribute('data-autoplay');
        let showControls = videoElement.getAttribute('data-controll');
        let isMute = videoElement.getAttribute('data-mute');

        var tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        
        window.player = null; 
        window.onYouTubeIframeAPIReady = function() {
            player = new YT.Player(wrapID, {
                height: '100%',
                width: '100%',
                videoId: videoID,
                playerVars: {
                    rel: 0,
                    autoplay: isAutoplay || 1,
                    modestbranding: 1,
                    autohide: 1,
                    mute: isMute || 1,
                    showinfo: 0,
                    controls: showControls || 0
                },
                events: {
                    'onStateChange': onPlayerStateChange
                }
            });
        }
        
        window.onPlayerReady = function(event) { 
            event.target.playVideo();
        }
        
        window.onPlayerStateChange = function(event) {
            if(event.data == YT.PlayerState.ENDED){
                if(document.getElementsByClassName(".video-thumb")[0]){
                    thumbElement.classList.remove("d-none");
                    videoWrapElement.classList.add("d-none");
                }else{
                    player.playVideo();
                }
            }
        }
        
        window.stopVideo = function() { 
            player.stopVideo();
        }
    }
    
    playVideo(event) {
        // Prevent page scroll when triggered by Space key
        if (event && event.type === 'keydown' && event.code === 'Space') {
            event.preventDefault()
        }
        this.thumbTarget.classList.add("d-none");
        this.videoWrapTarget.classList.remove("d-none");
        window.player.playVideo();
    }

    
}
